// Product-note versions are independent of deployments. Never move acknowledgement backward.
export const seenKey = (viewer) => `growthos.hub.updates.seen.${encodeURIComponent(viewer)}`;
const sequenceOf = (value) => /^\d+$/.test(String(value)) && Number.isSafeInteger(Number(value)) ? Number(value) : 0;
const memory = new Map();
export const browserStorage = () => { try { return window.localStorage; } catch { return undefined; } };
export function readSeen(viewer, storage = browserStorage()) {
  let saved = 0;
  try { saved = sequenceOf(storage?.getItem(seenKey(viewer))); } catch { /* private browser */ }
  return Math.max(saved, memory.get(viewer) || 0);
}
export function acknowledge(viewer, sequence, storage = browserStorage()) {
  const next = Math.max(readSeen(viewer, storage), sequenceOf(sequence));
  memory.set(viewer, next);
  try { storage?.setItem(seenKey(viewer), String(next)); } catch { /* page-memory fallback */ }
  return next;
}
